import VehicleLocatorAlertsSymbolizer from "./VehicleLocatorAlertsSymbolizer.js";
export default {
  install(molten) {
    molten.addPlugin('MapBoxSymbolizer', {
      type: VehicleLocatorAlertsSymbolizer.TYPE,
      objectType: ['vehicle', 'locator'],
      symbolizer: VehicleLocatorAlertsSymbolizer,
      name: VehicleLocatorAlertsSymbolizer.name
    });
  }
};